import DocTitle from 'react-document-title'

export default DocTitle
